// extracted by mini-css-extract-plugin
export default {"customerJourneyMap":"CustomerJourneyMap_customerJourneyMap__U6maj","customerJourneyMapImage":"CustomerJourneyMap_customerJourneyMapImage__M6hRK"};